module.exports = __webpack_public_path__ + "img/ic_help_white_24px@2x.9834f195.png";